<template>
  <section class="consumables-panel">
    <div class="consumables-grid">
      <consumable-card
        v-for="key in consumableKeys"
        :key="key"
        :protocol="protocol"
        :consumable-key="key"
      />
    </div>
    <div class="consumable-legend">
      <div><span class="legend-block legend-block--green"></span>剩余净化水量</div>
      <div><span class="legend-block legend-block--blue"></span>剩余天数</div>
    </div>
  </section>
</template>

<script>
import { CONSUMABLE_DISPLAY_ORDER } from "../../utils/protocol/filter";
import ConsumableCard from "./ConsumableCard.vue";

export default {
  name: "ConsumablesPanel",
  components: { ConsumableCard },
  props: {
    protocol: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      consumableKeys: CONSUMABLE_DISPLAY_ORDER.slice()
    };
  }
};
</script>

<style scoped>
.consumables-grid {
  position: absolute;
  top: 812px;
  left: 504px;
  display: flex;
  width: 800px;
  height: 240px;
  flex-wrap: wrap;
}

.consumable-legend {
  position: absolute;
  top: 913px;
  left: 1328px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
}

.consumable-legend > div {
  display: flex;
  align-items: center;
}

.consumable-legend > div + div { margin-top: 14px; }

.legend-block {
  width: 12px;
  height: 12px;
  margin-right: 4px;
  border-radius: 1px;
}

.legend-block--green { background: linear-gradient(270deg, #00ffa6 0%, #049344 100%); }
.legend-block--blue { background: linear-gradient(270deg, #0095ff 0%, #004f99 100%); }
</style>
